/**
 * Structured browser logging — one plain object per line, mirroring the JSON
 * shape the Worker (edge_request) and Go backend (http_request) emit, so a
 * request_id copied from the browser console can be pasted straight into a
 * Cloudflare Workers Logs query.
 *
 * Deliberately dependency-free: a log library adds npm supply-chain surface
 * for zero benefit in the browser.
 */

export type LogLevel = "debug" | "info" | "warn" | "error";

export function logEvent(
  level: LogLevel,
  event: string,
  fields: Record<string, unknown> = {}
): void {
  console[level]({ event, ts: new Date().toISOString(), ...fields });
}
